import { Outlet, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import Header from './Header';
import Footer from './Footer';

type ActiveLink = 'home' | 'articles' | 'plugins' | 'convert' | 'faq';

function Layout() {
  const { pathname } = useLocation();

  const activeLink: ActiveLink | undefined = (() => {
    const segment = pathname.split('/').filter(Boolean)[1];
    if (!segment) return 'home';
    if (segment === 'articles') return 'articles';
    if (segment === 'plugins') return 'plugins';
    if (segment === 'convert') return 'convert';
    if (segment === 'faq') return 'faq';
    return undefined;
  })();

  return (
    <>
      <Toaster position="top-right" expand richColors />
      <div className="flex flex-col min-h-screen bg-gray-100">
        <Header activeLink={activeLink} />
        <main id="main-content" className="flex-1" role="main">
          <Outlet />
        </main>
        <Footer />
      </div>
    </>
  );
}

export default Layout;
